import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"

import { connect, useSelector, useDispatch } from "react-redux"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { Link, NavLink } from "react-router-dom"
// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import Knob from "../../pages/AllCharts/knob/knob"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Header = props => {
  const { ProfileData } = useSelector(state => state.Profile)
  const [user, setUser] = useState({
    userName: "User",
    profileCompletion: 0,
    avatar: "",
  })
  const [userType, setUserType] = useState(
    JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))
  )

  const { employeeProfile, employeeData } = useSelector(
    state => state.employeeReducer
  )

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const { completionPercentage, errors } = useSelector(
    state => state.profileReducer
  )
  const knobHandleChange = data => {
    console.log(data)
  }

  useEffect(() => {
    // console.log(ProfileData.avatar)

    if (userType === "Admin") {
      if (ProfileData) {
        localStorage.setItem(
          "WWINGS_USER_INFO",
          JSON.stringify({
            userName: ProfileData.name ? ProfileData.name : "Admin",
            avatar: ProfileData.avatar ? ProfileData.avatar : "",
            profileCompletion: completionPercentage,
          })
        )
      }
    } else {
      if (employeeProfile) {
        localStorage.setItem(
          "WWINGS_USER_INFO",
          JSON.stringify({
            userName: employeeProfile.first_name
              ? employeeProfile.first_name
              : "Employee",
            avatar: employeeProfile.avatar ? employeeProfile.avatar : "",
            profileCompletion: completionPercentage,
          })
        )
      }
    }
  }, [ProfileData, employeeProfile])

  const [dropdownOpen, setDropdownOpen] = useState(false)

  const toggle = () => setDropdownOpen(prevState => !prevState)

  const type = localStorage.getItem("type")
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {/* <p className="h4 mt-1">Welcome {user.userName || "User"}</p> */}

            {userType && userType === "Admin" ? (
              <p className="h4 mt-1">Welcome {ProfileData.name}</p>
            ) : userType && userType === "superAdmin" ? null : (
              employeeProfile &&
              employeeProfile.first_name &&
              employeeProfile.first_name
            )}
          </div>

          <div className="d-flex">
            {userType === "superAdmin" ? null : (
              <div className="d-flex align-items-center cursor-pointer p-2">
                {/* <Link to={"/upgrade-plan"}>
                  <button className="mt-0 btn btn-rounded btn-outline-primary">
                    Upgrade to Premium
                  </button>
                </Link> */}
                {type !== "Premium User" ? (
                  <Link to={"/upgrade-plan"}>
                    <button className="mt-0 btn btn-rounded btn-outline-primary">
                      Upgrade to Premium
                    </button>
                  </Link>
                ) : (
                  <Link to={"/premium"}>
                    <button className="mt-0 btn btn-rounded btn-outline-primary">
                      Premium
                    </button>
                  </Link>
                )}
              </div>
            )}

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {userType === "superAdmin" ? null : (
                  <Knob
                    className={"my-auto"}
                    value={Math.floor(
                      localStorage.getItem("completionPercentage")
                    )}
                    height={30}
                    width={30}
                    fgColor="#556ee6"
                    displayCustom={() => {
                      return false
                    }}
                    onChange={knobHandleChange}
                  />
                )}

                {userType === "superAdmin" ? null : (
                  <div className="dropdown d-none d-lg-inline-block ms-1">
                    <button
                      className="btn header-item noti-icon ">
                      <Link
                        to={"/get-all-policy-reports"}
                      >
                        <i className="bx bx-down-arrow-circle" />
                      </Link>
                    </button>


                  </div>
                )}

                {userType === "superAdmin" ? null : (
                  <div className="dropdown d-none d-lg-inline-block ms-1">
                    <button
                      type="button"
                      onClick={() => {
                        toggleFullscreen()
                      }}
                      className="btn header-item noti-icon "
                      data-toggle="fullscreen"
                    >
                      <i className="bx bx-fullscreen" />
                    </button>
                  </div>
                )}

                {userType === "superAdmin" ? null : <NotificationDropdown />}
                {userType === "superAdmin" ? null : (
                  <div className="dropdown d-lg-inline-block ms-1">
                    <NavLink to={"/contactus"}>
                      {" "}
                      <span className="rounded-circle header-profile-user">
                        <i className="mdi mdi-headset fs-3" />
                        {/* <FontAwesomeIcon icon="fa-regular fa-headset" /> */}
                      </span>
                    </NavLink>
                  </div>
                )}

                <ProfileMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
